<template>
  <v-layout row wrap justify-center align-center>
    <v-flex xs12 >
      <h2>Projeto - {{ projetoData.name }}  
        <v-icon @click="dialogFiltro = true" class="lupa">search</v-icon></h2> 
      <v-expansion-panel v-if="this.$store.state.selectedRole.name !== 'Aluno'">
        <v-expansion-panel-content >
          <div slot="header">Detalhes do projeto {{ projetoData.name }}</div>
          <v-card class="mb-2">
            <v-card-title class="ml-4">
              <v-flex xs12 md3>
                <v-avatar tile class="text-xs-center" size="150">
                  <img :src="projetoData.image_medium" @error="imageError()" ref="logo" class="rounded-corner" alt>
                  <v-btn
                    absolute
                    dark
                    fab
                    bottom
                    right
                    color="blue"
                    small
                    class="image-edit"
                    @click.prevent="imageChangeModal = true"
                    v-if="this.$store.state.selectedRole.name === 'Admin' || 
                          this.$store.state.selectedRole.name === 'Mediador' || 
                          permissao"
                  >
                    <v-icon>mode_edit</v-icon>
                  </v-btn>
                </v-avatar>
                <change-image
                  v-if="imageChangeModal"
                  @imageCropped="imageProject"
                  @modalClose="imageChangeModal = false"
                  :isShow="imageChangeModal"
                ></change-image>
              </v-flex>
              <v-flex xs12 md9 justify-start>
                <v-icon
                  v-if="editing"
                  size="25"
                  @click="dialogDel = true"
                  style="float: right"
                >delete</v-icon>
                <v-spacer></v-spacer>
                <profile-text 
                  v-if="isMakerlab"
                  title="Nome : " 
                  v-model="projetoData.name" 
                  ></profile-text>
                <profile-text 
                  v-if="!isMakerlab"
                  title="Nome : " 
                  v-model="projetoData.name" 
                  :editing="editing"></profile-text>
                <profile-text
                  v-if="isMakerlab"
                  title="Descrição : "
                  v-model="projetoData.description"
                  input-type="multilinetext"
                ></profile-text>
                <profile-text
                  v-if="!isMakerlab"
                  title="Descrição : "
                  v-model="projetoData.description"
                  :editing="editing"
                  input-type="multilinetext"
                ></profile-text>
                <profile-text
                  v-if="!isMakerlab"
                  title="Justificativa : "
                  v-model="projetoData.justificativa"
                  :editing="editing"
                  input-type="multilinetext"
                ></profile-text>
                <profile-text
                  v-if="!isMakerlab"
                  title="Recursos : "
                  v-model="projetoData.recursos"
                  :editing="editing"
                  input-type="multilinetext"
                ></profile-text>
                <profile-text
                  v-if="isMakerlab"
                  title="Objetivo : "
                  v-model="projetoData.objetivo"
                  input-type="multilinetext"
                ></profile-text>
                <profile-text
                  v-if="!isMakerlab"
                  title="Objetivo : "
                  v-model="projetoData.objetivo"
                  :editing="editing"
                  input-type="multilinetext"
                ></profile-text>
                <div style="height: 1rem"></div>
                <p>
                  <strong style="font-size: 1.2rem" >Mediador:</strong>
                  <v-chip v-if="!editing || this.$store.state.selectedRole.name === 'Mediador'" desable color="blue" outline>{{projetoData.moderador}}</v-chip>
                </p>
                <v-select
                  v-if="editing && this.$store.state.selectedRole.name !== 'Mediador'"
                  label="Mediador"
                  :items="listamediador"
                  item-text="username"
                  item-value="username"
                  autocomplete
                  v-model="projetoData.moderador"
                  max-height="400"
                  hint="Escolha o responsável pelo projeto"
                  persistent-hint
                ></v-select>
                <p v-if="!editing">
                  <strong style="font-size: 1.2rem">Alunos:</strong>
                  <v-chip
                    v-for="un 
                              in projetoData.integrantes"
                    :key="un.name"
                    desable
                    color="blue"
                    v-if="un.status !== 'Saiu'"
                    outline
                  >
                    <v-avatar>
                      <img :src="un.profilePic" alt>
                    </v-avatar>
                    {{un.username}}
                  </v-chip>
                </p>
                <status-component
                  :columns="getIntegrantes"
                  @status-change="integrantesChange($event)"
                  v-if="(this.$store.state.selectedRole.name === 'Admin' || 
                                      this.$store.state.selectedRole.name === 'Mediador') && editing"
                />
                <v-select
                  v-if="editing && !isMakerlab"
                  label="Autores"
                  :items="alunos"
                  item-text="username"
                  item-value="id"
                  autocomplete
                  v-model="projetoData.integrantes_pks"
                  max-height="400"
                  hint="Escolha os autores do projeto"
                  persistent-hint
                  multiple
                ></v-select>
              </v-flex>
            </v-card-title>
            <v-btn
              v-if="this.$store.state.selectedRole.name === 'Admin' || 
                      this.$store.state.selectedRole.name === 'Mediador' || permissao "
              absolute
              dark
              fab
              bottom
              right
              color="blue"
              @click="pressFloatingButton()"
            >
              <v-icon v-if="!editing">mode_edit</v-icon>
              <v-icon v-else>done</v-icon>
            </v-btn>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>
      <v-flex xs12 class="" v-if="atividades.length > 0" >
        <fade-transition :duration="600" v-if="refresh">
          <v-expansion-panel style="width: 100%" class="mt-2" v-if="$store.state.selectedRole.name !== 'Aluno'">
            <v-expansion-panel-content v-if="showCard" >
              <div slot="header"> Atividades </div>
              <v-card raised tile v-for="(atividade, index) in atividades" :key="index">
                <v-layout row wrap xs12 class="pl-3">
                  <profile-text title="Nome : " v-model='atividade.title'
                    :last="true"></profile-text>  
                  <v-icon
                    v-if="!ativShow[index]"
                    size="25"
                    @click="show(index)"
                    style=" margin-top: 15px" 
                  >
                    keyboard_arrow_down
                  </v-icon>    
                  <v-icon
                    v-if="ativShow[index]"
                    size="25"
                    @click="show(index)"
                    style="margin-top: 15px" 
                  >
                    keyboard_arrow_up
                  </v-icon>          
                </v-layout>
                <!-- <hr v-if="!ativShow[index]"> -->
                <div v-if="ativShow[index]">
                  <v-card-text style="margin-left: 5px"> 
                  <profile-text title="Descrição : " v-model='atividade.description'
                    :last="true"
                    input-type='multilinetext'></profile-text>
                  <profile-text title="Objetivo : " v-model='atividade.objetivo'
                    :last="true"
                    input-type='multilinetext'></profile-text>                  
                  </v-card-text>
                  <show-criterio
                  style="width: 100%"
                  :criterios="atividade.habilidades"
                  :titulo="false"
                  :solicitacao="solicitacao"
                  :botaosaved="botaosaved"
                  :btnedit="false">
                  </show-criterio>
                  <v-btn color="primary"
                  @click.stop="editarAtividade(atividade, index)"
                  flat 
                  v-if="permissao "
                  >Editar atividade</v-btn>
                  <hr>
                </div>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </fade-transition>
      </v-flex>           
      <v-flex xs12 class="" v-if="solicitacoes.length > 0">
      <fade-transition :duration="600" >
        <v-expansion-panel style="width: 100%" class="mt-2" v-if="refresh">
          <v-expansion-panel-content v-if="showSol" >
            <div slot="header"> Solicitações de evidência </div>
            <v-card raised tile v-for="(tarefas, index) in solicitacoes" :key="tarefas.obrigatorias" >
                <v-layout row wrap xs12 class="pl-3">
                  <profile-text title="Nome : " v-model='tarefas.title'
                    :last="true"></profile-text> 
                  <v-icon
                    v-if="!solShow[index]"
                    size="25"
                    @click="show2(index)"
                    style=" margin-top: 15px" 
                  >
                    keyboard_arrow_down
                  </v-icon>    
                  <v-icon
                    v-if="solShow[index]"
                    size="25"
                    @click="show2(index)"
                    style="margin-top: 15px" 
                  >
                    keyboard_arrow_up
                  </v-icon>          
                </v-layout>
                <div v-if="solShow[index]">
                  <v-card-text v-if="refresh" style="margin-left: 5px">
                    <profile-text title="Descrição : " v-model='tarefas.description'
                    :last="true"
                    input-type='multilinetext'></profile-text>
                  </v-card-text>
                  <show-criterio
                  style="width: 100%"
                  :criterios="tarefas.habilidades"
                  >
                  </show-criterio>
                  <v-btn color="primary"
                  flat 
                  @click.stop="editar(tarefas, index)"
                  v-if="permissao "
                  >Editar solicitação</v-btn>
                  <hr>
                </div>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </fade-transition>
      </v-flex>      
    <v-layout align-center justify-center row fill-height>
      <v-progress-circular
        indeterminate
        align-center
        :size="50"
        style="text-align: center"
        color="primary"
        v-if="waiting"
      ></v-progress-circular>
    </v-layout>
    <v-container fluid class="mx-0 px-0">
      <!-- <div class="my-cards"> -->
      <v-layout xs12 row wrap>
        <v-flex xs6 
          v-for="(evidencia, index) in evidencias.results"
          :key="evidencia.id">
          <transition-group
            :duration="600"
          >   
            <v-card 
            key="card.id"
              class="ma-2"
              v-if="evidencia.author === $store.state.user.username || 
                    evidencia.status === 'P' || evidencia.status === 'F' || 
                    showEvidencia">
              
              <v-card-title class="text-xs-center ">
                  <v-layout row >
                      <v-flex xs4>
                        <h2 class="headline" style="text-align: left">{{evidencia.title}}</h2>
                      </v-flex>
                      <v-flex xs3>
                        <img :src="evidencia.image" height="60" width="60" alt="">
                      </v-flex>
                      <v-flex xs5>
                          <v-layout row style="text-align: right" align-content-end
                            justify-end>
                              <v-spacer></v-spacer>

                          <v-layout align-end column class='mr-2'>
                              <v-flex>  
                              <h4>
                                  {{evidencia.author}}
                              </h4>
                              </v-flex>
                              <v-flex>
                              {{ evidencia.modified | moment('LL') }}
                              </v-flex>
                          </v-layout>
                              <div v-if="evidencia.auto_avaliado" style="height: 55px; width: 55px; background: #90e1f0 ; border-radius: 30px ">
                                  <v-avatar class="ma-1">
                                      <img :src="getUserImage(evidencia.author)" alt="" style="margin-right: 2px" >
                                  </v-avatar>
                                  <div class="badge1">
                                      <v-icon class="mr-3" v-if="evidencia.status === 'A' || evidencia.status === 'F'">school</v-icon>
                                      <v-icon class="" v-if="evidencia.status === 'P' || evidencia.status === 'F'">public</v-icon>
                                  </div>
                              </div>
                              <div v-else >
                                  <v-avatar >
                                      <img :src="getUserImage(evidencia.author)" alt="" >
                                  </v-avatar>
                                  <div class="badge1">
                                      <v-icon class="mr-3" v-if="evidencia.status === 'A' || evidencia.status === 'F'">school</v-icon>
                                      <v-icon class="" v-if="evidencia.status === 'P' || evidencia.status === 'F'">public</v-icon>
                                  </div>
                              </div>

                          </v-layout>
                      </v-flex>
                      <!-- <div style="height: 65px"></div> -->
                  </v-layout> 
                </v-card-title>
                <v-layout row wrap>
                  <a v-if="showBtn" @click="expandir(index)">Visualizar</a>
                  <div v-if="evidencia.audio !== null" >
                    <v-icon class="ml-2">audiotrack</v-icon>
                  </div>
                  <div v-if="evidencia.video !== null">
                    <v-icon class="ml-2">play_circle_outline</v-icon>
                  </div>
                </v-layout>
              </v-card>
              <div key="div.id">
                <v-dialog v-model="dialogEvi[index]" max-width="500"> 
                  <evidencia
                    class="mb-2"
                    v-if="evidencias.results[index].author === $store.state.user.username || 
                          evidencias.results[index].status === 'P' || evidencias.results[index].status === 'F' || 
                          showEvidencia"
                    style="display: inline-block; width:100%;"
                    :image="getUserImage(evidencias.results[index].author)"
                    :evidencia="evidencias.results[index]"
                    :avaliavel="true"
                    :moreopts="false"
                    @changed="mudouEvidencia"
                    @exclui="retirarevid"
                    @avaliar="abrirAvaliacao(evidencia)"
                  />
                </v-dialog>
              </div>
          </transition-group>
        <!-- </div> -->
        </v-flex>
      </v-layout>
    </v-container>
    <v-flex xs12 justify-center class="text-xs-center mt-3">
      <v-pagination :length="evidencias.pages" total-visible="7" circle v-model="page"></v-pagination>      
    </v-flex>
            

      <!-- dialog de deletar projeto-->
      <v-dialog v-model="dialogDel" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Deseja deletar?</v-card-title>
          <v-card-text>Gostaria excluir esse projeto com suas solicitacoes e atividades ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="dialogDel = false">Cancelar</v-btn>
            <v-btn color="green darken-1" flat @click.native="excluir()">Deletar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
      v-model="snackbar"
      bottom
      color="success">
      {{ text }}
        <v-btn flat color="black" @click.native="snackbar = false">Close</v-btn>
      </v-snackbar>

      <!-- dialog de deletar solicitacao -->
      <v-dialog v-model="delTaf" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Deseja deletar?</v-card-title>
          <v-card-text>Gostaria excluir essa solicitação ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="delTaf = false">Cancelar</v-btn>
            <v-btn color="green darken-1" flat @click.native="excluirTaf()">Deletar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- dialog de deletar atividade -->
      <v-dialog v-model="delAtividade" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Deseja deletar?</v-card-title>
          <v-card-text>Gostaria excluir essa atividade ?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="delAtividade = false">Cancelar</v-btn>
            <v-btn color="green darken-1" flat @click.native="excluirAtividade()">Deletar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
      v-model="snackbar"
      bottom
      color="success">
      {{ text }}
        <v-btn flat color="black" @click.native="snackbar = false">Close</v-btn>
      </v-snackbar>

      <!-- dialog de filtro-->
      <v-dialog v-model="dialogFiltro" persistent max-width="400">
        <v-card>
          <v-card-title class="headline"> <v-spacer></v-spacer> Filtro de evidências?<v-spacer></v-spacer> </v-card-title>
          <v-card-text>
            <v-autocomplete 
              label="Autores"
              :items="projetoData.integrantes"
              item-text="username"
              item-value="id"
              autocomplete
              v-model="alunoFilter"
              hint="Escolha o aluno"
              style="margin-bottom: 15px"
            ></v-autocomplete>
            <v-checkbox label="Avaliadas"
              class="upCheck"
              v-if="!isNotAvaliada"
              v-model="isAvaliada"></v-checkbox>
            <v-checkbox label="Não avaliadas"
              class="upCheck"
              v-if="!isAvaliada"
              v-model="isNotAvaliada"></v-checkbox>
            <v-checkbox label="Evidência foco"
              class="upCheck"
              v-if="!isNotFocus"
              v-model="isFocus"></v-checkbox>
            <v-checkbox label="Evidência não foco"
              class="upCheck"
              v-if="!isFocus"
              v-model="isNotFocus"></v-checkbox>
            <v-layout row wrap>
                <v-flex xs6>
                  <v-menu
                    ref="menu"
                    lazy
                    :close-on-content-click="false"
                    v-model="menu"
                    transition="scale-transition"
                    offset-y
                    style="width: 80%"
                    :nudge-right="40"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Data de início"
                      v-model="computedDateFormatted"
                      prepend-icon="event"
                    ></v-text-field>
                    <v-date-picker v-model="dateInicio" no-title scrollable
                      locale="pt-br">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.menu.save(dateInicio)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6>
                  <v-menu
                    ref="menu2"
                    lazy
                    :close-on-content-click="false"
                    v-model="menu2"
                    transition="scale-transition"
                    offset-y
                    style="width: 80%"
                    :nudge-right="40"
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      label="Data do fim"
                      v-model="computedDateFormatted2"
                      prepend-icon="event"
                    ></v-text-field>
                    <v-date-picker v-model="dateFim" no-title scrollable
                      locale="pt-br">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.menu2.save(dateFim)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="fecharFiltro()">Limpar</v-btn>
            <v-btn color="green darken-1" flat @click.native="filtrar()">Pesquisar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



      <!-- Dialog do editar  atividade-->

      <v-dialog id="dialog" v-model="dialogAtividade" max-width="100%">
      <v-card>
        <v-card-title> 
          <h1>Editar Atividade</h1>

          <v-icon
            size="25"
            @click="delAtividade = true"
            style="position: absolute; top: 8px; right: 16px" 
          >
            delete
          </v-icon> 
        </v-card-title>
        <v-card-text>
          <v-text-field 
            label="Titulo da atividade" 
            ref="obs"
            hint="Exemplo: Aula 1"
            v-model="atividadeTitulo"></v-text-field>
          <v-text-field 
            label="Descrição da atividade" 
            hint="Descreva o que necessita para realização da atividade"
            v-model="atividadeDescricao"></v-text-field>
            <v-text-field 
            label="Objetivo da atividade" 
            hint="Descreva o objetivo da atividade"
            v-model="atividadeObjetivo"></v-text-field>
          </v-card-text>
          <v-card-text>
            <h2>Resumo das habilidades já selecionadas</h2>
            <v-data-table
              :headers="headers"
              :items="editHabil.habilidades"
              item-key="id"
              hide-actions
              class="elevation-1"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                    <span slot="activator">
                    {{ props.header.text }}
                    </span>
                    <span>
                    {{ props.header.text }}
                    </span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <td >{{ props.item.classificacao }}</td>
                <td >{{ props.item.grupo }}</td>
                <td >{{ props.item.subgrupo }}</td>
                <td >{{ props.item.name }}</td>
              </template>
            </v-data-table>
          </v-card-text>
        <v-card-actions>
          <input-criterios-aval 
            style="width: 100%"
            :criterios="criterios"
            :titulo="titulo"
            :clear="clear"
            :btnedit="btnedit"
            :editHabil="editHabil"
            @saved="criteriosSelecionados"
            @edit="editAtividade"
            @cancel="dialogAtividade = false"
          >
          </input-criterios-aval>
        </v-card-actions>
      </v-card>
    </v-dialog>


      <!-- Dialog do editar  Solicitação-->

      <v-dialog id="dialog" v-model="dialog" max-width="100%">
      <v-card>
        <v-card-title> 
          <h1>Editar Solicitação</h1>

          <v-icon
            size="25"
            @click="delTaf = true"
            style="position: absolute; top: 8px; right: 16px" 
          >
            delete
          </v-icon> 
        </v-card-title>
        <v-card-text>
          <v-text-field 
            label="Titulo da atividade" 
            ref="obs"
            hint="Exemplo: Aula 1"
            v-model="tarefatitulo"></v-text-field>
          <v-text-field 
            label="Descrição da atividade" 
            hint="Descreva o que necessita para realização da atividade"
            v-model="tarefadescricao"></v-text-field>
          </v-card-text>
        <v-card-actions>
          <input-criterios-aval 
            style="width: 100%"
            :criterios="criterios"
            :titulo="titulo"
            :clear="clear"
            :btnedit="btnedit"
            :editHabil="editHabil"
            @saved="criteriosSelecionados"
            @edit="editAtual"
            @cancel="dialog = false"
          >
          </input-criterios-aval>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-layout>
</template>

<script>
import api from '@/api';
import ProfileText from '@/components/reusable/ProfileText.vue';
import Evidencia from '@/components/reusable/evidencia.vue';
import AvalDialogContent from '@/components/reusable/AvalDialogContent.vue';
import ChangeImage from '@/components/reusable/ChangeImage.vue';
import { FadeTransition } from 'vue2-transitions';
import InputCriteriosAval from '@/components/reusable/inputCriteriosAval.vue';
import ShowCriterio from '@/components/reusable/showCriterio.vue';
import StatusComponent from '@/components/reusable/StatusComponent.vue';
export default {
  components: {
    ProfileText,
    AvalDialogContent,
    Evidencia,
    ChangeImage,
    FadeTransition,
    InputCriteriosAval,
    ShowCriterio,
    StatusComponent
  },
  data () {
    return {
      currentTab: 'Sobre',
      showImageUpload: false,
      imageChangeModal: false,
      ativShow: [false, false, false, false, false, false, false, false, false],
      solShow: [false, false, false, false, false, false, false, false, false],
      showSol: true,
      showCard: true,
      projetoData: [],
      editing: false,
      delTaf: false,
      delAtividade: false,
      showBtn: true,
      dialogDel: false,
      dialog: false,
      evid_avaliada: {},
      dialog_criterios: false,
      dialogAtividade: false,
      dialogFiltro: false,
      alunoFilter: '',
      dialogEvi: [false, false, false, false, false, false, false, false, false],
      btnDialog: false,
      snackbar: false,
      text: 'Evidência excluída',
      pesquisa: '',
      tempData: {},
      options: {},
      solicitacao: false,
      botaosaved: false,
      evidencias: {},
      atividades: [],
      solicitacoes: [],
      criterios: [],
      avaliacoes: [],
      tarefatitulo: '',
      titulo: true,
      btnedit: false,
      clear: true,
      isAvaliada: false,
      isFocus: false,
      isNotFocus: false,
      isNotAvaliada: false,
      menu: false,
      menu2: false,
      dateFim: '',
      dateInicio: '',
      tarefadescricao: '',
      atividadeTitulo: '',
      atividadeDescricao: '',
      atividadeObjetivo: '',
      onerror: '',
      src: '',
      salvandoCriterio: [],
      refresh: true,
      editHabil: [],
      projectid: '',
      search: '',
      selected: [],
      lista: [],
      criteriosSelecionados: [],
      waiting: true,
      alunos: [],
      listamediador: [],
      page: 1,
      alunos_ids_old: {
        pausa: [],
        progresso: [],
        concluido: []
      },
      alunos_ids: {
        pausa: [],
        progresso: [],
        concluido: []
      },
      headers: [
        {text: 'Classificação', value: 'classificacao'},
        {text: 'Grupo', value: 'grupo'},
        {text: 'Subgrupo', value: 'subgrupo'},
        {text: 'Habilidade ou Competência', value: 'name'}
      ]
    };
  },
  mounted () {
    console.log('data', new Date().toISOString())
    this.projectid = this.$route.params.id;
    api.request('GET', 'projetos/' + this.projectid + '/').then(response => {
      this.projetoData = response.data;
      this.getStudents(this.projetoData.moderador);
      this.getMediador()
      this.getCriterios()
    })
    this.getEvidencia()
    this.getAtividades()

    api.request('GET', 'tarefas/?projeto__id=' + this.projectid).then(resp => {
      this.solicitacoes = resp.data
      console.log(resp.data)
    })

    this.$watch('projetoData.moderador', function () {
      this.getStudents(this.projetoData.moderador);
    })
    this.$watch('evidencias', function () {
      // this.refreshUI()
    });
  },
  watch: {
    page (val, oldVal) {
      this.getEvidencia(val);
    }
  },
  computed: {
    getIntegrantes () {
      var progresso = [];
      var pausa = [];
      var concluido = [];
      progresso = this.projetoData.integrantes.filter(
        obj => obj.status === 'Em Progresso'
      );
      pausa = this.projetoData.integrantes.filter(
        obj => obj.status === 'Em Pausa'
      );
      concluido = this.projetoData.integrantes.filter(
        obj => obj.status === 'Finalizado'
      );
      this.alunos_ids_old.progresso = progresso.map(item => item.id);
      this.alunos_ids_old.pausa = pausa.map(item => item.id);
      this.alunos_ids_old.concluido = concluido.map(item => item.id);
      return [pausa, progresso, concluido];
    },
    safeImage () {
      if (
        this.projetoData.image === '' ||
        this.projetoData.image === undefined
      ) {
        return 'https://firebasestorage.googleapis.com/v0/b/mundomaker-staging.appspot.com/o/images%2Fdefault-user-image.png?alt=media';
      } else {
        return this.projetoData.image;
      }
    },
    permissao () {
      if (this.$store.state.user.is_superuser) {
        return true
      } else {
        return this.$store.state.details.can_delete_project
      }
    },
    computedDateFormatted () {
      return this.formatDate(this.dateInicio)
    },
    computedDateFormatted2 () {
      return this.formatDate(this.dateFim)
    },
    showEvidencia () {
      if (this.$store.state.user.is_superuser) {
        return true
      }
      if (this.$store.state.selectedRole.name === 'Mediador') {
        if (this.projetoData.moderador === this.$store.state.user.username) {
          return true
        } else {
          return false
        }
      }
      if (this.$store.state.selectedRole.name !== 'Aluno') {
        return true
      }
    },
    isMakerlab () {
      return this.$store.state.company.makerlab;
    }
  },
  methods: {
    calcularIdsDosAlunos () {},
    expandir (i) {
      this.showBtn = false
      this.dialogEvi[i] = true
      this.showBtn = true
    },
    abrirAvaliacao (evidencia) {
      this.evid_avaliada = evidencia;
      // this.avaliando = true
      this.$store.commit('SET_EVID', evidencia);
      this.$router.push('/projetos/' + evidencia.id + '/avaliacao');
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    criaAvaliacoes () {
      this.dialog_criterios = false;
      let avaliacoes = [];
      this.selected.forEach(val => {});
      this.avaliacoes = avaliacoes;
    },
    goToUnidade (unidade) {
      this.$router.push('/unidade/' + unidade);
    },
    imageError () {
      this.onerror = null
      this.$refs.logo.src = this.projetoData.image
    },
    integrantesChange (change) {
      console.log('changed integrantes');
      console.log(change);
      var progresso = [];
      var pausa = [];
      var concluido = [];
      progresso = change[1];
      pausa = change[0];
      concluido = change[2];
      this.alunos_ids.progresso = progresso.map(item => item.id);
      this.alunos_ids.pausa = pausa.map(item => item.id);
      this.alunos_ids.concluido = concluido.map(item => item.id);
      var diffpausa = this.alunos_ids.pausa.filter(
        x => !this.alunos_ids_old.pausa.includes(x)
      );
      var diffprogresso = this.alunos_ids.progresso.filter(
        x => !this.alunos_ids_old.progresso.includes(x)
      );
      var diffconcluido = this.alunos_ids.concluido.filter(
        x => !this.alunos_ids_old.concluido.includes(x)
      );
      var alunosArray = [];
      var status = '';
      if (diffpausa.length > 0) {
        status = 'P';
        alunosArray = diffpausa;
      } else if (diffprogresso.length > 0) {
        status = 'A';
        alunosArray = diffprogresso;
      } else {
        status = 'F';
        alunosArray = diffconcluido;
      }
      api.request('POST', 'projetos-change-status/', {
        projeto: this.projectid,
        alunos: alunosArray,
        status: status
      });
      console.log('here');
      console.log(change);
      console.log('pausa: ', diffpausa);
      console.log('progresso: ', diffprogresso);
      console.log('concluido: ', diffconcluido);
    },
    getAtividades () {
      api.request('GET', 'atividade/?projeto__id=' + this.projectid).then(resp => {
        this.atividades = resp.data.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
        console.log('atividades', resp.data)
        this.$store.commit('SET_ATIVIDADES', resp.data.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0)))
      })
    },
    getCriterios () {
      api.request('GET', 'criterioavaliacao/').then(response => {
        this.criterios = response.data;
      });
    },
    excluir () {
      api
        .request('DELETE', 'projetos/' + this.$route.params.id + '/')
        .then(resp => {
          if (this.solicitacoes.length === 0) {
            if (this.atividades.length === 0) {
              this.$router.push('/projetos')
            }
          }
          if (this.atividades.length !== 0) {
            for (let index = 0; index < this.atividades.length; index++) {
              console.log('atividade', this.atividades[index].id)
              api
              .request('DELETE', 'atividade/' + this.atividades[index].id + '/')
              .then(response => {
                if (this.solicitacoes.length === 0) {
                  this.$router.push('/projetos')
                }
              })
            }
          }
          if (this.solicitacoes.length !== 0) {
            for (let index = 0; index < this.solicitacoes.length; index++) {
              console.log('solicitacao', this.solicitacoes[index].id)
              api.request('DELETE', 'tarefas/' + this.solicitacoes[index].id + '/').then(response => {
                this.$router.push('/projetos')
              })
            }
          }
        })
    },
    getUserImage (username) {
      var userarray = this.projetoData.integrantes.filter(value => {
        return value.username === username;
      });
      if (userarray[0]) {
        console.log('username', username)
        console.log('userarray', userarray)

        return userarray[0].profilePic;
      } else {
        return '';
      }
    },
    fecharFiltro () {
      this.pesquisa = ''
      this.page = 1
      this.alunoFilter = ''
      this.isAvaliada = false
      this.isFocus = false
      this.isNotFocus = false
      this.isNotAvaliada = false
      this.dialogFiltro = false
      this.getEvidencia()
    },
    filtrar () {
      this.pesquisa = ''
      if (this.alunoFilter) {
        this.pesquisa = this.pesquisa + '&author=' + this.alunoFilter
      }
      if (this.isAvaliada) {
        this.pesquisa = this.pesquisa + '&is_evaluated=true'
      }
      if (this.isNotAvaliada) {
        this.pesquisa = this.pesquisa + '&is_not_evaluated=true'
      }
      if (this.isFocus) {
        this.pesquisa = this.pesquisa + '&is_focus_evidence=true'
      }
      if (this.isNotFocus) {
        this.pesquisa = this.pesquisa + '&is_not_focus_evidence=true'
      }
      if (this.dateInicio) {
        this.pesquisa = this.pesquisa + '&created__gte=' + this.dateInicio + 'T00:00:19.920Z'
      }
      if (this.dateFim) {
        this.pesquisa = this.pesquisa + '&created__lte=' + this.dateFim + 'T23:30:19.920Z'
      }
      this.getEvidencia()
    },
    getUser (username) {
      var userarray = this.projetoData.integrantes.filter(value => {
        return value.username === username;
      });
      return userarray[0];
    },
    getEvidencia (page = 1) {
      api
        .request(
          'GET',
          'evidencias/?page=' + page + '&project=' + this.$route.params.id + this.pesquisa
        )
        .then(response => {
          this.evidencias = response.data;
          console.log('evid', response.data);
          this.dialogFiltro = false
          this.waiting = false;
        });
    },
    mudouEvidencia (evidencia) {
      // console.log('evidencia', evidencia)
      var ind;
      var found = this.evidencias.results.some((evid, index) => {
        ind = index;
        return evidencia.id === evid.id;
      });
      if (!found) {
        // console.log('Erro');
        return false;
      }
      this.evidencias.results.splice(ind, 1, evidencia);
      // console.log(ind)
    },
    pressFloatingButton () {
      if (this.editing) {
        this.performSave();
      } else {
        this.editing = !this.editing;
      }
    },
    performSave () {
      var projectid = this.$route.params.id;
      var nomes = this.projetoData.integrantes_pks.map(user => {
        return user;
      });
      let self = this;
      api
        .request('PATCH', 'projetos/' + projectid + '/', {
          description: self.projetoData.description,
          name: self.projetoData.name, // vai editar nome?
          justificativa: self.projetoData.justificativa,
          recursos: self.projetoData.recursos,
          objetivo: self.projetoData.objetivo,
          moderador: self.projetoData.moderador,
          integrantes_pks: nomes
        })
        .then(function (response) {
          self.refreshUI();
          // console.log(response);
        });
      self.editing = false;
    },
    retirarevid (retirar) {
      var posic;
      var busca = this.evidencias.results.some((evid, index) => {
        posic = index;
        return retirar === evid.id;
      });
      if (!busca) {
        // console.log('Erro');
        return false;
      }
      this.evidencias.results.splice(posic, 1);
      this.snackbar = true;
    },
    imageProject (image) {
      var path = 'projetos/' + this.$route.params.id + '/';

      var name =
        'images/projetos/' +
        'projectPic_' +
        this.$route.params.id +
        '.jpg&' +
        new Date().getTime();

      var upload = this.fbstorage.child(name).putString(image, 'data_url');

      upload.on(
        'state_changed',
        snapshot => console.log(snapshot),
        error => console.log(error),
        url => {
          console.log(upload.snapshot);
          var payload = {
            image: name
          };
          api.request('PATCH', path, payload).then(resp => {
            // console.log(resp.data)
            this.imageChangeModal = false;
            this.refreshUI();
          });
        }
      );
    },
    getStudents (mediador) {
      api
        .request('GET', 'search-user?mediador__username=' + mediador)
        .then(response => {
          this.alunos = response.data;
        });
    },
    getMediador () {
      api.request('GET', 'search-user?groups__name=Mediador').then(resp => {
        this.listamediador = resp.data;
      });
    },
    oneError () {
      alert('uiah')
    },
    refreshUI () {
      this.refresh = false;
      var projectid = this.$route.params.id;
      api.request('GET', 'projetos/' + projectid + '/').then(response => {
        this.refresh = false;
        this.projetoData = response.data;
        this.getEvidencia();
        this.refresh = true;
      });
      api.request('GET', 'tarefas/?projeto__id=' + projectid).then(resp => {
        this.refresh = false;
        this.atividades = resp.data;
        this.refresh = true;
      });
      this.refresh = false;
      this.getAtividades()
      this.refresh = true;
    },
    editar (value, index) {
      console.log(value, index)
      this.editHabil = value
      this.tarefatitulo = value.title
      this.tarefadescricao = value.description
      this.ident = index
      console.log(index)
      this.btnedit = true
      this.dialog = true
    },
    editarAtividade (value, index) {
      console.log(value, index)
      this.editHabil = value
      this.atividadeTitulo = value.title
      this.atividadeDescricao = value.description
      this.atividadeObjetivo = value.objetivo
      this.ident = index
      this.btnedit = true
      this.dialogAtividade = true
    },
    excluirTaf () {
      api.request('DELETE', 'tarefas/' + this.editHabil.id + '/').then(response => {
        this.delTaf = false
        this.dialog = false
        this.refreshUI()
      })
    },
    excluirAtividade () {
      api.request('DELETE', 'atividade/' + this.editHabil.id + '/').then(response => {
        this.delAtividade = false
        this.dialogAtividade = false
        this.refreshUI()
      })
    },
    editAtual (value) {
      console.log(value)
      for (let index = 0; index < value.length; index++) {
        this.lista[index] = value[index].id
      }
      console.log(this.lista)

      this.salvandoCriterio = {
        'title': this.tarefatitulo,
        'description': this.tarefadescricao,
        'evidencia_foco': true,
        'habilidades_pks': this.lista
      }
      api.request('PATCH', 'tarefas/' + this.editHabil.id + '/', this.salvandoCriterio).then(response => {
        console.log(response)
        this.tarefatitulo = ''
        this.tarefadescricao = ''
        this.tarefaData = ''
        this.editHabil = []
        this.lista = []

        this.refreshUI()
      })

      this.dialog = false
    },
    show (i) {
      this.showCard = false
      if (this.ativShow[i] === false) {
        this.ativShow[i] = true
      } else {
        this.ativShow[i] = false
      }
      this.showCard = true
    },
    show2 (i) {
      this.showSol = false
      if (this.solShow[i] === false) {
        this.solShow[i] = true
      } else {
        this.solShow[i] = false
      }
      this.showSol = true
    },
    editAtividade (value) {
      console.log(value)
      for (let index = 0; index < value.length; index++) {
        this.lista[index] = value[index].id
      }
      console.log(this.lista)

      this.salvandoCriterio = {
        'title': this.atividadeTitulo,
        'description': this.atividadeDescricao,
        'objetivo': this.atividadeObjetivo,
        'habilidades_pks': this.lista
      }
      api.request('PATCH', 'atividade/' + this.editHabil.id + '/', this.salvandoCriterio).then(response => {
        console.log(response)
        this.atividadeTitulo = ''
        this.atividadeDescricao = ''
        this.atividadeObjetivo = ''
        this.editHabil = []
        this.lista = []

        this.refreshUI()
      })

      this.dialogAtividade = false
    }
  }
};
</script>

<style lang="scss" scoped>
.video-player {
  width: 100%;
}
.image-edit {
  margin-right: -20px;
  margin-bottom: 15px;
}
.smaller-tabs {
  .tabs__div {
    font-size: 0.9rem;
  }
}

.rounded-corner {
  border-radius: 10px;
}

/* CSS do player */

.vjs-custom-skin > .video-js {
  width: 100%;
  font-family: "PingFang SC", "Helvetica Neue", "Hiragino Sans GB", "Segoe UI",
    "Microsoft YaHei", "微软雅黑", sans-serif;
}

.vjs-custom-skin > .video-js .vjs-menu-button-inline.vjs-slider-active,
.vjs-custom-skin > .video-js .vjs-menu-button-inline:focus,
.vjs-custom-skin > .video-js .vjs-menu-button-inline:hover,
.video-js.vjs-no-flex .vjs-menu-button-inline {
  width: 10em;
}

.vjs-custom-skin > .video-js .vjs-controls-disabled .vjs-big-play-button {
  display: none !important;
}

.vjs-custom-skin > .video-js .vjs-control {
  width: 3em;
}

.vjs-custom-skin > .video-js .vjs-control.vjs-live-control {
  width: auto;
  padding-left: 0.5em;
  letter-spacing: 0.1em;
}

.vjs-custom-skin > .video-js .vjs-menu-button-inline:before {
  width: 1.5em;
}

.vjs-menu-button-inline .vjs-menu {
  left: 3em;
}

.vjs-paused.vjs-has-started.vjs-custom-skin > .video-js .vjs-big-play-button,
.video-js.vjs-ended .vjs-big-play-button,
.video-js.vjs-paused .vjs-big-play-button {
  display: block;
}

.vjs-custom-skin > .video-js .vjs-load-progress div,
.vjs-seeking .vjs-big-play-button,
.vjs-waiting .vjs-big-play-button {
  display: none !important;
}

.vjs-custom-skin > .video-js .vjs-mouse-display:after,
.vjs-custom-skin > .video-js .vjs-play-progress:after {
  padding: 0 0.4em 0.3em;
}

.video-js.vjs-ended .vjs-loading-spinner {
  display: none;
}

.video-js.vjs-ended .vjs-big-play-button {
  display: block !important;
}

.video-js.vjs-ended .vjs-big-play-button,
.video-js.vjs-paused .vjs-big-play-button,
.vjs-paused.vjs-has-started.vjs-custom-skin > .video-js .vjs-big-play-button {
  display: block;
}

.vjs-custom-skin > .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-left: -1.5em;
  margin-top: -1em;
}

.vjs-custom-skin > .video-js .vjs-big-play-button {
  background-color: rgba(0, 0, 0, 0.45);
  font-size: 3.5em;
  /*border-radius: 50%;*/
  height: 2em !important;
  line-height: 2em !important;
  margin-top: -1em !important;
}

.video-js:hover .vjs-big-play-button,
.vjs-custom-skin > .video-js .vjs-big-play-button:focus,
.vjs-custom-skin > .video-js .vjs-big-play-button:active {
  background-color: rgba(36, 131, 213, 0.9);
}

.vjs-custom-skin > .video-js .vjs-loading-spinner {
  border-color: rgba(36, 131, 213, 0.8);
}

.vjs-custom-skin > .video-js .vjs-control-bar2 {
  background-color: #000000;
}

.vjs-custom-skin > .video-js .vjs-control-bar {
  /*background-color: rgba(0,0,0,0.3) !important;*/
  color: #ffffff;
  font-size: 14px;
}

.vjs-custom-skin > .video-js .vjs-play-progress,
.vjs-custom-skin > .video-js .vjs-volume-level {
  background-color: #2483d5;
}

.vjs-custom-skin > .video-js .vjs-play-progress:before {
  top: -0.3em;
}

.vjs-custom-skin > .video-js .vjs-progress-control:hover .vjs-progress-holder {
  font-size: 1.3em;
}

.vjs-menu-button-popup.vjs-volume-menu-button-vertical .vjs-menu {
  left: 0em;
}

.vjs-custom-skin > .video-js .vjs-menu li {
  padding: 0;
  line-height: 2em;
  font-size: 1.1em;
  font-family: "PingFang SC", "Helvetica Neue", "Hiragino Sans GB", "Segoe UI",
    "Microsoft YaHei", "微软雅黑", sans-serif;
}

.vjs-custom-skin > .video-js .vjs-time-tooltip,
.vjs-custom-skin > .video-js .vjs-mouse-display:after,
.vjs-custom-skin > .video-js .vjs-play-progress:after {
  border-radius: 0;
  font-size: 1em;
  padding: 0;
  width: 3em;
  height: 1.5em;
  line-height: 1.5em;
  top: -3em;
}

.vjs-custom-skin > .video-js .vjs-menu-button-popup .vjs-menu {
  width: 5em;
  left: -1em;
}

.vjs-custom-skin
  > .video-js
  .vjs-menu-button-popup.vjs-volume-menu-button-vertical
  .vjs-menu {
  left: 0;
}

// .vjs-custom-skin > .video-js .vjs-control-bar .vjs-resolution-button .vjs-menu {
//   /*order: 4;*/
// }

/*排序顺序*/
.vjs-custom-skin > .video-js .vjs-control-bar .vjs-play-control {
  order: 0;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-time-control {
  min-width: 1em;
  padding: 0;
  margin: 0 0.1em;
  text-align: center;
  display: block;
  order: 1;
}

.vjs-custom-skin
  > .video-js
  .vjs-control-bar
  .vjs-playback-rate
  .vjs-playback-rate-value {
  font-size: 1.2em;
  line-height: 2.4;
}

.vjs-custom-skin > .video-js .vjs-progress-control.vjs-control {
  order: 2;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-volume-menu-button {
  order: 3;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-resolution-button {
  order: 4;
}

.vjs-custom-skin
  > .video-js
  .vjs-control-bar
  .vjs-resolution-button
  .vjs-resolution-button-label {
  display: block;
  line-height: 3em;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-playback-rate {
  order: 5;
}

.vjs-custom-skin > .video-js .vjs-control-bar .vjs-fullscreen-control {
  order: 6;
}

.my-cards {
  column-count: 2;
  column-gap: 1em;
}

.redondo {
  width: 2.7rem;
  height: 2.7rem;
  color: #fff;
  background-color: white;
  border: 1px black solid;
  margin-left: 0px;
  border-radius: 50%;
}
.image-edit {
  margin-right: -20px;
  margin-bottom: 15px;
}
.lupa {
  position: absolute;
  right: 50px;
}
.upCheck {
  margin-top: -15px
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Projetos/Detail.vue